import { Transaction } from "./Transaction";
import { GICTransaction } from "./GICTransaction";
import { CashTransaction } from "./CashTrasanction";
import { BondTransaction } from "./BondTransaction";
import { Price } from "./Price";
import Holding from "./Holding";
import { ETransactionType, ITransRow, TransFields } from "../shared/ITransaction";
import Utils from "../libs/Utils";

export function createTransactionRow(type:ETransactionType, accountId:number, ticker:string, price:number, quantity:number, note:string) : Partial<ITransRow> {
    return {
        [TransFields.type] : type,
        [TransFields.account] : accountId,
        [TransFields.ticker] : ticker,
        [TransFields.price] : price,
        [TransFields.quantity] : quantity,
        [TransFields.note] : note,
        [TransFields.date] : Utils.formatDate("yyyy-MM-dd", new Date())
    }
}
export default function createTrans(ticker:string, holding:Holding, json:Partial<ITransRow>):Transaction{
    if (Price.isGIC(ticker) || Price.isSave(ticker)) return new GICTransaction(holding, json)
    else if (Price.isBond(ticker)) return new BondTransaction(holding, json)
    else if (Price.isCash(ticker)) return new CashTransaction(holding, json)
    else return new Transaction(holding,json)
}